import FactSection2 from './FactSection2';

export default FactSection2;